var _style, _circle, _polygon, _feBlend, _feBlend2, _mask, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagAprendiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.32 50",
    style: {
      enableBackground: "new 0 0 47.32 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000080925479498998158500000006073952732811932330_);}\r\n\t.st2{fill:url(#SVGID_00000083073256738870790580000011555337486099652999_);}\r\n\t.st3{fill:url(#SVGID_00000067206680944064718580000006338201719782002619_);}\r\n\t.st4{fill:#EDF5FE;}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000081641592878599989240000006343254154759272855_);}\r\n\t\r\n\t\t.st7{mask:url(#SVGID_00000005269038964459588590000011874186408571880874_);fill:url(#SVGID_00000005986114539226009010000017856582085753827974_);}\r\n\t.st8{fill:url(#SVGID_00000111154000646894254240000017952258501054769297_);}\r\n\t.st9{fill:url(#SVGID_00000017503488801104620160000008591130722277790911_);}\r\n\t.st10{fill:url(#SVGID_00000103965033573848181850000006350051011182044079_);}\r\n\t.st11{fill:url(#SVGID_00000098934052957446895030000011031748405135489979_);}\r\n\t.st12{fill:url(#SVGID_00000082365698539003851400000015912472647970539649_);}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:url(#SVGID_00000137840684886631725260000014615006936325534387_);}\r\n\t.st15{fill:url(#SVGID_00000000945088733812554020000018356407128510241163_);}\r\n\t.st16{fill:url(#SVGID_00000003101871809257501320000015499335213469136256_);}\r\n\t.st17{fill:url(#SVGID_00000136398786161449871090000011580291331097639066_);}\r\n\t.st18{fill:url(#SVGID_00000107578240130866654550000005031455033256638894_);}\r\n\t.st19{fill:url(#SVGID_00000152976161060676919720000016030771344063634063_);}\r\n\t.st20{fill:url(#SVGID_00000122688515660577580110000012076003784850297271_);}\r\n\t.st21{fill:url(#SVGID_00000092423201798036904830000001270280538417887880_);}\r\n\t.st22{fill:url(#SVGID_00000178194078620169768120000007059700704464102563_);}\r\n\t.st23{filter:url(#Adobe_OpacityMaskFilter_00000101085377819376870860000011467810748714372789_);}\r\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000024715379759431154440000009790716750826175623_);}\r\n\t\r\n\t\t.st25{mask:url(#SVGID_00000168812209942043774410000003030793359873218228_);fill:url(#SVGID_00000055687299045408598480000004340113992314309007_);}\r\n\t.st26{fill:url(#SVGID_00000013158729413403364350000012882367767512679072_);}\r\n\t.st27{fill:url(#SVGID_00000101076420469159303010000000991308439697601715_);}\r\n\t.st28{fill:url(#SVGID_00000094580969727691306510000017060794999097303683_);}\r\n\t.st29{fill:url(#SVGID_00000179646183986807521420000006797765057325725113_);}\r\n\t.st30{fill:url(#SVGID_00000121971145790388111210000018107974164806294920_);}\r\n\t.st31{fill:url(#SVGID_00000141434295498283670350000000116590107505379509_);}\r\n\t.st32{fill:url(#SVGID_00000156586744843501028570000003390117700664459960_);}\r\n\t.st33{filter:url(#Adobe_OpacityMaskFilter_00000065060773004804402960000010617130985140474272_);}\r\n\t.st34{filter:url(#Adobe_OpacityMaskFilter_00000095340434345015376660000016129375935688380296_);}\r\n\t\r\n\t\t.st35{mask:url(#SVGID_00000101073897783825894360000002110969590987287185_);fill:url(#SVGID_00000053526439370016404040000015187614668972062854_);}\r\n\t.st36{fill:url(#SVGID_00000013167969761356533190000018234097763905341872_);}\r\n\t.st37{fill:url(#SVGID_00000160871776552787965330000011526937106045138621_);}\r\n\t.st38{fill:url(#SVGID_00000090296858987684659560000017869628082812560566_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6886,
    y1: 43.2569,
    x2: 23.6886,
    y2: 3.637979e-12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B65F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#487EF8"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.69,
    cy: 21.63,
    r: 21.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040561780442908408560000013555907789061392787_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6886,
    y1: 41.8678,
    x2: 23.6886,
    y2: 1.3891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56ABF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191E96"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000040561780442908408560000013555907789061392787_)"
    },
    cx: 23.69,
    cy: 21.63,
    r: 20.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160184954078932454540000005644614831527967898_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6886,
    y1: 41.0691,
    x2: 23.6886,
    y2: 2.1878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#053FFC"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160184954078932454540000005644614831527967898_)"
    },
    cx: 23.69,
    cy: 21.63,
    r: 19.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133488328388445779200000017590299120334636184_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6577,
    y1: 50,
    x2: 23.6577,
    y2: 29.7754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EDFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133488328388445779200000017590299120334636184_)"
    },
    d: "M35.45,48.2 c0.12,1.22-1.11,2.12-2.23,1.64l-5.57-2.36l-3.96-1.68l-3.96,1.68l-5.63,2.39c-1.11,0.47-2.32-0.4-2.23-1.6l1.41-18.49h20.37 L35.45,48.2z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "27.65,33.82 27.65,47.49 23.69,45.81 19.73,47.49 19.73,33.82  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 8.22,
    y: 7.94,
    width: 30.93,
    height: 30.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.22,
    y: 7.94,
    width: 30.93,
    height: 30.93,
    id: "SVGID_00000054964160163684545490000013856655701630644368_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000080206931332168717000000012225705685141552807_",
    filterUnits: "userSpaceOnUse",
    x: 8.22,
    y: 7.94,
    width: 30.93,
    height: 30.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.22,
    y: 7.94,
    width: 30.93,
    height: 30.93,
    id: "SVGID_00000054964160163684545490000013856655701630644368_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166667167491382813710000014555044831204387493_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6886,
    y1: 38.8767,
    x2: 23.6886,
    y2: 7.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000054964160163684545490000013856655701630644368_)",
      fill: "url(#SVGID_00000166667167491382813710000014555044831204387493_)"
    },
    d: " M26.19,9.06L26.19,9.06c2.13-2.36,6.03-0.74,5.87,2.43v0c-0.1,2,1.54,3.64,3.54,3.54h0c3.17-0.16,4.79,3.74,2.43,5.87l0,0 c-1.48,1.34-1.48,3.67,0,5.01l0,0c2.36,2.13,0.74,6.03-2.43,5.87h0c-2-0.1-3.64,1.54-3.54,3.54v0c0.16,3.17-3.74,4.79-5.87,2.43 l0,0c-1.34-1.48-3.67-1.48-5.01,0l0,0c-2.13,2.36-6.03,0.74-5.87-2.43v0c0.1-2-1.54-3.64-3.54-3.54h0 c-3.17,0.16-4.79-3.74-2.43-5.87l0,0c1.48-1.34,1.48-3.67,0-5.01l0,0c-2.36-2.13-0.74-6.03,2.43-5.87h0 c2,0.1,3.64-1.54,3.54-3.54v0c-0.16-3.17,3.74-4.79,5.87-2.43l0,0C22.52,10.55,24.85,10.55,26.19,9.06z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049193010676288294110000015783190392069443003_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6886,
    y1: 38.8767,
    x2: 23.6886,
    y2: 7.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049193010676288294110000015783190392069443003_)"
    },
    d: "M26.19,9.06L26.19,9.06 c2.13-2.36,6.03-0.74,5.87,2.43v0c-0.1,2,1.54,3.64,3.54,3.54h0c3.17-0.16,4.79,3.74,2.43,5.87l0,0c-1.48,1.34-1.48,3.67,0,5.01 l0,0c2.36,2.13,0.74,6.03-2.43,5.87h0c-2-0.1-3.64,1.54-3.54,3.54v0c0.16,3.17-3.74,4.79-5.87,2.43l0,0 c-1.34-1.48-3.67-1.48-5.01,0l0,0c-2.13,2.36-6.03,0.74-5.87-2.43v0c0.1-2-1.54-3.64-3.54-3.54h0c-3.17,0.16-4.79-3.74-2.43-5.87 l0,0c1.48-1.34,1.48-3.67,0-5.01l0,0c-2.36-2.13-0.74-6.03,2.43-5.87h0c2,0.1,3.64-1.54,3.54-3.54v0 c-0.16-3.17,3.74-4.79,5.87-2.43l0,0C22.52,10.55,24.85,10.55,26.19,9.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077312411249196322350000018029317220731364517_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2217,
    y1: 21.6284,
    x2: 39.1554,
    y2: 21.6284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05A0D1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077312411249196322350000018029317220731364517_)"
    },
    d: "M26.19,7.28L26.19,7.28 c2.13-2.36,6.03-0.74,5.87,2.43v0c-0.1,2,1.54,3.64,3.54,3.54h0c3.17-0.16,4.79,3.74,2.43,5.87l0,0c-1.48,1.34-1.48,3.67,0,5.01 l0,0c2.36,2.13,0.74,6.03-2.43,5.87h0c-2-0.1-3.64,1.54-3.54,3.54v0c0.16,3.17-3.74,4.79-5.87,2.43l0,0 c-1.34-1.48-3.67-1.48-5.01,0l0,0c-2.13,2.36-6.03,0.74-5.87-2.43v0c0.1-2-1.54-3.64-3.54-3.54h0c-3.17,0.16-4.79-3.74-2.43-5.87 l0,0c1.48-1.34,1.48-3.67,0-5.01l0,0c-2.36-2.13-0.74-6.03,2.43-5.87h0c2,0.1,3.64-1.54,3.54-3.54v0 c-0.16-3.17,3.74-4.79,5.87-2.43l0,0C22.52,8.77,24.85,8.77,26.19,7.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174593243466841216060000012699035837830693018_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6883,
    y1: 31.9398,
    x2: 23.6883,
    y2: 11.3172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#175CD8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174593243466841216060000012699035837830693018_)"
    },
    d: "M34,21.63c0,0.3-0.01,0.6-0.04,0.89 c-0.45,5.28-4.88,9.42-10.27,9.42c-5.4,0-9.82-4.14-10.27-9.42c-0.03-0.29-0.04-0.59-0.04-0.89c0-5.69,4.62-10.31,10.31-10.31 C29.38,11.32,34,15.93,34,21.63z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.35,16.51l1.26,2.56c0.11,0.22,0.32,0.37,0.56,0.4L29,19.89c0.61,0.09,0.85,0.83,0.41,1.26l-2.04,1.99 c-0.17,0.17-0.25,0.41-0.21,0.65l0.48,2.81c0.1,0.6-0.53,1.06-1.07,0.78l-2.53-1.33c-0.22-0.11-0.47-0.11-0.69,0l-2.53,1.33 c-0.54,0.29-1.18-0.18-1.07-0.78l0.48-2.81c0.04-0.24-0.04-0.48-0.21-0.65l-2.04-1.99c-0.44-0.43-0.2-1.17,0.41-1.26l2.82-0.41 c0.24-0.03,0.45-0.19,0.56-0.4l1.26-2.56C23.3,15.96,24.08,15.96,24.35,16.51z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M4.96,24.61L4.96,24.61c0-1.06-0.86-1.92-1.92-1.92v0c1.06,0,1.92-0.86,1.92-1.92h0 c0,1.06,0.86,1.92,1.92,1.92v0C5.82,22.7,4.96,23.55,4.96,24.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1.11,
    cy: 29.04,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 38.12,
    cy: 7.87,
    r: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M41.33,2.75c0,0.34-0.27,0.61-0.61,0.61c-0.34,0-0.61-0.27-0.61-0.61s0.27-0.61,0.61-0.61 C41.06,2.15,41.33,2.42,41.33,2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M44.34,41.11L44.34,41.11c0-1.64-1.33-2.98-2.98-2.98v0c1.64,0,2.98-1.33,2.98-2.98h0 c0,1.64,1.33,2.98,2.98,2.98v0C45.67,38.13,44.34,39.47,44.34,41.11z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagAprendiz);
export default __webpack_public_path__ + "static/media/tag_aprendiz.a997eb4459ce0391cd3bd097e5c67580.svg";
export { ForwardRef as ReactComponent };